import _toConsumableArray from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import splitToWords from "./splitToWords";
import insertGap from "./insertGap";
/*
  This function is firstly converting "repeat(3, 1fr) 2fr" to plain format that is compatible with IE
  For simplicity, the IE compatible format "(1fr)[3]" for repeat is not used
  Also if gap is defined, it adds gap after each column/row
 */

var compatibleGridTemplate = function compatibleGridTemplate(cells, gap) {
  var cellsMap = splitToWords(cells);
  var plainCells = cellsMap && cellsMap.map(function (item) {
    if (/repeat\((.*\))/g.test(item)) {
      var values = /repeat\((\d+),\s(.*\)?)\)/g.exec(item);
      return values && Array.apply(void 0, _toConsumableArray(Array(Number(values[1])))).map(function () {
        return values[2];
      }).join(" ");
    }

    return item;
  }).join(" ");

  if (!gap) {
    return plainCells;
  }

  return insertGap(plainCells, gap);
};

export default compatibleGridTemplate;